export default __webpack_public_path__ + "static/Carousel-Integration@2x-3f101ac71d61de5b5da0141fefdb2b90.png";